import * as materials from "materials/legacy/legacy-mix";
export { materials };
export default materials;
